import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '../../svgIcon/SvgIcon';

export const NotificationPermission = (props) => (
    <SvgIcon {...props}>
        <path fill="#353535" d="M18.03 20.53c.92 0 1.66.74 1.66 1.66 0 .92-.74 1.66-1.66 1.66s-1.66-.74-1.66-1.66c0-.92.74-1.66 1.66-1.66zm36.02 18.03V54c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V30.47h25.7c-.3-.65-.57-1.31-.79-2H3V18c0-1.1.9-2 2-2h23.47c.29-.69.64-1.35 1.02-2H5c-2.21 0-4 1.79-4 4v36c0 2.21 1.79 4 4 4h47.05c2.21 0 4-1.79 4-4V37.22c-.63.49-1.3.94-2 1.34zM5.32 22.18c0 .92.74 1.66 1.66 1.66.92 0 1.66-.74 1.66-1.66 0-.92-.74-1.66-1.66-1.66-.92.01-1.66.75-1.66 1.66zm5.52 0c0 .92.74 1.66 1.66 1.66s1.66-.74 1.66-1.66c0-.92-.74-1.66-1.66-1.66s-1.66.75-1.66 1.66zm25.97 6.14c-.11-.32-.06-.6.13-.78l1.37-1.69v-5.56c0-3.15 2.14-5.88 5.13-6.58 0-.86.7-1.56 1.56-1.56s1.56.7 1.56 1.56c2.98.7 5.13 3.43 5.13 6.58v5.56l1.49 1.76c.1.19.1.45.01.72-.14.28-.37.43-.63.43h-3.83v.34c0 .76-.4 1.45-1.16 1.98-.71.5-1.62.77-2.58.77-.95 0-1.87-.27-2.58-.77-.73-.51-1.16-1.25-1.16-1.98v-.34h-3.83c-.22-.01-.51-.14-.61-.44zm13.13-2.23v-5.8c0-2.7-2.22-4.95-4.95-5.01-2.72 0-4.94 2.25-4.94 5.01v5.8l-.62.85h11.12l-.61-.85zm-2.96 2.66h-3.97v.34c0 .15.2.4.52.56.36.24.9.37 1.47.37.54 0 1.03-.12 1.45-.36.33-.17.53-.42.53-.57v-.34z" />
        <path fill="#eda821" d="M45.05 7c-8.82 0-16 7.18-16 16s7.18 16 16 16 16-7.18 16-16-7.17-16-16-16zm0 30c-7.72 0-14-6.28-14-14s6.28-14 14-14 14 6.28 14 14-6.28 14-14 14z" />
        { props.blocked && <path fill="#eda821" transform="rotate(-45.001 45 23)" d="M29.44 21.85h31.11v2.3H29.44z" /> }
    </SvgIcon>
);

NotificationPermission.propTypes = {
    blocked: PropTypes.bool
};

NotificationPermission.defaultProps = {
    viewBox: '0 0 64 64'
};

export default NotificationPermission;
